import { FormField, FormItem, FormLabel } from '@/components/ui/form';
import { TimeInputField } from '@/domain/termine/components/TimeInput/TimeInputField';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export function TimeInputFormField({ name }: { name: 'beginn' | 'ende' }) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();
  const errors = form.formState.errors;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex-1 md:flex-none">
          <FormLabel>
            {name === 'ende'
              ? t('domain.termine.sheet.fields.bis')
              : t('domain.termine.sheet.fields.von')}
          </FormLabel>
          <TimeInputField
            {...field}
            className={cn(
              'w-full md:w-20',
              name === 'ende' && errors.ende && 'border-primary-red-R400',
            )}
          />
        </FormItem>
      )}
    />
  );
}
